import { render, staticRenderFns } from "./CompanyAddSuccessModal.vue?vue&type=template&id=512008a0&scoped=true&"
import script from "./CompanyAddSuccessModal.vue?vue&type=script&lang=js&"
export * from "./CompanyAddSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAddSuccessModal.vue?vue&type=style&index=0&id=512008a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512008a0",
  null
  
)

export default component.exports